import { render, staticRenderFns } from "./USDTCard.vue?vue&type=template&id=7bfb53d4&"
import script from "./USDTCard.vue?vue&type=script&lang=js&"
export * from "./USDTCard.vue?vue&type=script&lang=js&"
import style0 from "./USDTCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports